module.exports = __webpack_public_path__ + "media/Video 27.3bf6bd89.mp4";